<span class="dot" [matTooltip]="tooltipText" matTooltipPosition="above"
      [ngClass]="{'flikering-dot': isFlickeringDot}"
      [ngStyle]="{'background-color': color }">
</span>
